import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const CategoryAPI = createApi({
    reducerPath: "CategoryAPI",
    baseQuery: fetchBaseQuery({
        baseUrl: BaseUrl,
        prepareHeaders: (headers, { endpoint }) => {
            const token = localStorage.getItem("accessToken");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            headers.set("Accept", "application/json");

            // Apply JSON content-type except for multipart endpoints
            if (!["addCategory", "updateCategory", "updateCategoryStatus"].includes(endpoint)) {
                headers.set("Content-Type", "application/json");
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        addCategory: builder.mutation({
            query: (formData) => ({
                url: "admin/categories",
                method: "POST",
                body: formData,
            }),
        }),

        updateCategory: builder.mutation({
            query: ({ formData, id }) => ({
                url: `admin/categories/update/${id}`,
                method: "POST",
                body: formData,
            }),
        }),

        getCategoryList: builder.query({
            query: () => `admin/categories`,
        }),

        getParentCategories: builder.query({
            query: () => `admin/list-parent-category`,
        }),

        getCategorybyId: builder.query({
            query: (id) => `admin/categories/show/${id}`,
        }),

        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `admin/categories/delete/${id}`,
                method: "DELETE",
            }),
        }),

        updateCategoryStatus: builder.mutation({
            query: (formData) => ({
                url: "admin/categories/update-status",
                method: "POST",
                body: formData,
            }),
        }),

        listActiveCategory: builder.query({
            query: () => `admin/list-active-category`,
        }),
    }),
});

export const {
    useAddCategoryMutation,
    useGetCategoryListQuery,
    useGetParentCategoriesQuery,
    useGetCategorybyIdQuery,
    useUpdateCategoryMutation,
    useDeleteCategoryMutation,
    useUpdateCategoryStatusMutation,
    useListActiveCategoryQuery,
} = CategoryAPI;
